import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import GeneralApiLoading from "../general/GeneralApiLoading";
import QFMainPane from "../general/QFMainPane";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { changeQuestionFlowUserMode } from "../store/components";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import {
  getCHSdata,
  getChsDataStatus,
  makeCurrentNodesToFirstNode,
} from "../store/qf";

const InsurerViewQF = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const chsdatastatus = useSelector(getChsDataStatus);
  const encryptedProspectId = search.substring(4);

  useEffect(() => {
    // add a dispatch here to change the mode to client
    dispatch(changeQuestionFlowUserMode(INSURER));
    dispatch(getCHSdata({ id: encryptedProspectId }));
  }, [dispatch, encryptedProspectId]);

  useEffect(() => {
    if (chsdatastatus === PossibleApiStatusValues.success) {
      // TODO: Change the current node to the first node of the first form
      dispatch(makeCurrentNodesToFirstNode());
    }
  });

  return (
    <GeneralApiLoading possibleApiValue={chsdatastatus}>
      <QFMainPane></QFMainPane>
    </GeneralApiLoading>
  );
};

export default InsurerViewQF;
